import { all } from "redux-saga/effects";
import { watchHttpAction } from "./httpRequestSaga";

function* rootSaga() {
  yield all([
    watchHttpAction(),
    // Add more sagas here as needed
  ]);
}

export default rootSaga;
